(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bottle-360"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-b360-stage]').forEach(function (stage) {
    var cyl = stage.querySelector('[data-b360-cyl]');
    if (!cyl) return;
    var deg = 0, vel = 0, dragging = false, lastX = 0, idle = 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function frame() {
      if (!dragging) {
        idle++;
        if (Math.abs(vel) > 0.05) { deg += vel; vel *= 0.95; }
        else if (!reduce && idle > 90) { deg += 0.18; }
      }
      cyl.style.transform = 'rotateY(' + deg + 'deg)';
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
    function down(x) { dragging = true; lastX = x; vel = 0; }
    function move(x) { if (!dragging) return; deg += (x - lastX) * 0.45; lastX = x; }
    function up(x) { if (!dragging) return; dragging = false; idle = 0; vel = (x - lastX) * 0.3; }
    cyl.addEventListener('pointerdown', function (e) { e.preventDefault(); cyl.setPointerCapture(e.pointerId); down(e.clientX); });
    cyl.addEventListener('pointermove', function (e) { move(e.clientX); });
    cyl.addEventListener('pointerup', function (e) { up(e.clientX); });
    cyl.addEventListener('pointercancel', function (e) { up(e.clientX); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mede a faixa de aviso para o sticky parar exatamente na barra de navegação
  (function () {
    var group = document.querySelector('.shopify-section-group-header-group');
    var header = document.querySelector('.site-header');
    if (!group || !header) return;
    var ann = header.querySelector('.site-header__announcement');

    function medir() {
      var h = ann ? Math.round(ann.getBoundingClientRect().height) : 0;
      group.style.setProperty('--ann-h', h + 'px');
    }
    medir();
    window.addEventListener('resize', medir, { passive: true });
    if (window.ResizeObserver && ann) new ResizeObserver(medir).observe(ann);

    // Sombra só quando a barra está grudada no topo
    function estado() {
      header.setAttribute('data-stuck', header.getBoundingClientRect().top <= 0 ? 'true' : 'false');
    }
    estado();
    window.addEventListener('scroll', estado, { passive: true });
    document.addEventListener('shopify:section:load', function () { medir(); estado(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-v4"] && !Shopify.designMode) return;
  try {
    
(function () {
  var v = document.querySelector('[data-hv4-video]');
  if (!v) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    v.removeAttribute('autoplay');
    v.pause();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // PDP — Purchase options + sticky cart
  (function() {
    const form = document.querySelector('#product-form');
    if (!form) return;

    // Purchase options sync
    const radios = form.querySelectorAll('input[name="purchase_option"]');
    const variantInput = form.querySelector('[data-selected-variant]');
    const planInput = form.querySelector('[data-selected-plan]');
    const stickyPrice = document.querySelector('[data-sticky-price]');

    const stickyTier = document.querySelector('[data-sticky-tier]');

    function updateSelection() {
      const selected = form.querySelector('input[name="purchase_option"]:checked');
      if (!selected) return;
      if (variantInput) variantInput.value = selected.dataset.variantId || '';
      if (planInput) planInput.value = selected.dataset.planId || '';

      // Update sticky bar from selected tier
      const card = selected.closest('.ptier');
      if (!card) return;
      const amount = card.querySelector('.ptier__amount')?.textContent?.trim();
      const label = card.querySelector('.ptier__label')?.textContent?.trim();
      if (stickyPrice && amount) stickyPrice.textContent = amount;
      if (stickyTier && label) stickyTier.textContent = label;
    }

    radios.forEach(r => r.addEventListener('change', updateSelection));
    updateSelection();

    // "Change" link in sticky bar — smooth scroll back to tier picker
    const stickyChange = document.querySelector('[data-sticky-change]');
    stickyChange?.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById('purchase-options');
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Highlight subtly
      target.classList.add('is-pulsed');
      setTimeout(() => target.classList.remove('is-pulsed'), 1400);
    });

    // Sticky cart visibility — show after scrolling past main CTA
    const stickyCart = document.querySelector('[data-sticky-cart]');
    const submitBtn = form.querySelector('button[type="submit"]');
    if (stickyCart && submitBtn && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const inView = entries[0].isIntersecting;
        stickyCart.classList.toggle('is-visible', !inView);
      }, { threshold: 0 });
      observer.observe(submitBtn);
    }

    // UGC modal — tap tile to expand into player
    const ugcModal = document.querySelector('[data-ugc-modal]');
    const ugcModalVideo = document.querySelector('[data-ugc-modal-video]');
    if (ugcModal && ugcModalVideo) {
      const ugcModalSource = ugcModalVideo.querySelector('source');
      document.querySelectorAll('[data-ugc-tile]').forEach((tile) => {
        tile.addEventListener('click', (e) => {
          if (e.target.closest('[data-ugc-close]')) return;
          const src = tile.querySelector('[data-ugc-video] source')?.src;
          if (!src) return;
          ugcModalSource.src = src;
          ugcModalVideo.load();
          ugcModalVideo.play();
          ugcModal.classList.add('is-open');
          ugcModal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        });
      });
      ugcModal.querySelectorAll('[data-ugc-close]').forEach((closer) => {
        closer.addEventListener('click', () => {
          ugcModal.classList.remove('is-open');
          ugcModal.setAttribute('aria-hidden', 'true');
          ugcModalVideo.pause();
          document.body.style.overflow = '';
        });
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && ugcModal.classList.contains('is-open')) {
          ugcModal.classList.remove('is-open');
          ugcModalVideo.pause();
          document.body.style.overflow = '';
        }
      });
    }

    // Gallery thumbs (basic — swaps main image)
    const thumbs = document.querySelectorAll('.product-gallery__thumb');
    const mainImg = document.querySelector('.product-gallery__main img');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const thumbImg = thumb.querySelector('img');
        if (!mainImg || !thumbImg) return;
        const thumbSrc = thumbImg.src;
        // Replace ?width=NNN if present, else just use src as-is
        const newSrc = thumbSrc.replace(/(\?|&)width=\d+/, '$1width=1500');
        mainImg.src = newSrc.includes('width=') ? newSrc : thumbSrc;
      });
    });
  })();

  // ── Product Tabs (How to use / Ingredients / Shipping) ──
  (function() {
    document.querySelectorAll('.ptabs').forEach((root) => {
      const tabs = root.querySelectorAll('.ptabs__tab');
      const panels = root.querySelectorAll('.ptabs__panel');

      function activate(idx) {
        tabs.forEach((tab, i) => {
          const active = i === idx;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel, i) => {
          const active = i === idx;
          panel.classList.toggle('is-active', active);
          if (active) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      }

      tabs.forEach((tab, idx) => {
        tab.addEventListener('click', () => activate(idx));
        tab.addEventListener('keydown', (e) => {
          let next = idx;
          if (e.key === 'ArrowRight') next = (idx + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
          else return;
          e.preventDefault();
          activate(next);
          tabs[next].focus();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp2-compare"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-p2-compare]').forEach(function (root) {
      var buttons = root.querySelectorAll('[data-p2-compare-btn]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.dataset.active = btn.dataset.p2CompareBtn;
          buttons.forEach(function (other) { other.setAttribute('aria-pressed', other === btn ? 'true' : 'false'); });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp2-formula"] && !Shopify.designMode) return;
  try {
    
  // Mobile: the actives row advances by itself, one card at a time, and pauses
  // while the person is touching or scrolling it. Desktop renders a grid (no-op).
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var rows = Array.prototype.slice.call(document.querySelectorAll('.pdp2-formula .pdp2-cluster__grid'));
    if (!rows.length) return;
    rows.forEach(function (row, n) {
      var timer = null;
      var pausedUntil = 0;
      var visible = false;
      var isScroller = function () { return row.scrollWidth - row.clientWidth > 8; };
      var step = function () {
        if (!visible || !isScroller() || Date.now() < pausedUntil) return;
        var cards = Array.prototype.slice.call(row.children);
        if (cards.length < 2) return;
        var x = row.scrollLeft;
        var base = row.offsetLeft + parseFloat(getComputedStyle(row).paddingLeft || 0);
        var left = null;
        for (var i = 0; i < cards.length; i++) {
          var cardLeft = cards[i].offsetLeft - base;
          if (cardLeft > x + 4) { left = cardLeft; break; }
        }
        var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
        if (left === null || atEnd) left = 0;
        row.scrollTo({ left: left, behavior: 'smooth' });
      };
      var start = function () {
        if (timer) return;
        timer = setInterval(step, 3600);
      };
      var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
      var hold = function () { pausedUntil = Date.now() + 7000; };
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) { row.addEventListener(ev, hold, { passive: true }); });
      row.addEventListener('focusin', hold);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) { pausedUntil = Date.now() + 1200 + n * 900; start(); } else { stop(); }
        }, { threshold: 0.5 }).observe(row);
      } else {
        visible = true; start();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp2-hero"]) return;
  try {
    
  // PDP v2 — hero: purchase selector, floating bar, gallery progress, shared scroll reveal.
  (function () {
    // Shared reveal for every pdp2-* section on the page.
    var revealEls = document.querySelectorAll('[data-p2-reveal]');
    if (revealEls.length) {
      var noMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!('IntersectionObserver' in window) || noMotion) {
        revealEls.forEach(function (el) { el.classList.add('is-seen'); });
      } else {
        var revealIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-seen');
            revealIO.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
        revealEls.forEach(function (el) { revealIO.observe(el); });
      }
    }

    // Brand videos: play only while on screen; each tile has its own pause control.
    var videos = document.querySelectorAll('[data-p2-video]');
    if (videos.length && 'IntersectionObserver' in window) {
      var allowMotion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var videoIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && allowMotion && video.dataset.userPaused !== 'true') {
            var p = video.play(); if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.35 });
      videos.forEach(function (video) { videoIO.observe(video); });
      document.querySelectorAll('[data-p2-video-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var video = btn.parentElement.querySelector('[data-p2-video]');
          if (!video) return;
          if (video.paused) {
            video.dataset.userPaused = 'false';
            var p = video.play(); if (p && p.catch) p.catch(function () {});
          } else {
            video.dataset.userPaused = 'true';
            video.pause();
          }
        });
      });
      videos.forEach(function (video) {
        var sync = function () {
          var btn = video.parentElement.querySelector('[data-p2-video-toggle]');
          if (!btn) return;
          btn.setAttribute('aria-pressed', video.paused ? 'true' : 'false');
          btn.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        };
        video.addEventListener('play', sync); video.addEventListener('pause', sync);
      });
    }

    // Swipeable rows are keyboard-focusable only while they actually scroll (they are plain grids on wide screens).
    var scrollers = document.querySelectorAll('[data-p2-scroller]');
    if (scrollers.length) {
      var syncScrollers = function () {
        scrollers.forEach(function (el) {
          if (el.scrollWidth > el.clientWidth + 4) el.setAttribute('tabindex', '0'); else el.removeAttribute('tabindex');
        });
      };
      syncScrollers();
      if ('ResizeObserver' in window) {
        var scrollerRO = new ResizeObserver(syncScrollers);
        scrollers.forEach(function (el) { scrollerRO.observe(el); });
      }
    }

    var root = document.querySelector('[data-pdp2-hero]');
    if (!root) return;
    var form = root.querySelector('#product-form');
    var plan = root.querySelector('[data-pdp2-plan]');
    if (!form || !plan) return;

    var variantInput = form.querySelector('[data-selected-variant]');
    var planInput = form.querySelector('[data-selected-plan]');
    var ctaPrice = root.querySelector('[data-cta-price]');
    var terms = root.querySelector('[data-pdp2-terms]');
    var barLabel = root.querySelector('[data-bar-label]');
    var barPrice = root.querySelector('[data-bar-price]');
    var radios = Array.prototype.slice.call(form.querySelectorAll('input[name="purchase_option"]'));
    var modeButtons = Array.prototype.slice.call(plan.querySelectorAll('[data-mode-btn]'));
    var lastSubscription = radios.filter(function (r) { return r.value !== 'single' && r.checked; })[0] ||
                           radios.filter(function (r) { return r.value !== 'single'; })[0] || null;

    function apply() {
      var selected = radios.filter(function (r) { return r.checked; })[0];
      if (!selected) return;
      if (variantInput) variantInput.value = selected.dataset.variantId || '';
      if (planInput) planInput.value = selected.dataset.planId || '';
      if (ctaPrice) ctaPrice.textContent = selected.dataset.price || '';
      if (terms) terms.textContent = selected.dataset.terms || '';
      if (barLabel) barLabel.textContent = selected.dataset.label || '';
      if (barPrice) barPrice.textContent = selected.dataset.price || '';
      var mode = selected.value === 'single' ? 'once' : 'subscribe';
      plan.dataset.mode = mode;
      modeButtons.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.dataset.modeBtn === mode ? 'true' : 'false');
      });
      if (selected.value !== 'single') lastSubscription = selected;
    }

    function select(radio) {
      if (!radio) return;
      radio.checked = true;
      apply();
    }

    radios.forEach(function (radio) { radio.addEventListener('change', apply); });
    modeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.modeBtn === 'once') {
          select(radios.filter(function (r) { return r.value === 'single'; })[0]);
        } else {
          select(lastSubscription);
        }
      });
    });

    // Deep links from the home offers: ?tier=single | subscribe-monthly | subscribe-quarterly
    var tier = new URLSearchParams(window.location.search).get('tier');
    if (tier) {
      var match = radios.filter(function (r) { return r.dataset.tier === tier; })[0];
      if (match) match.checked = true;
    }
    apply();

    // Floating bar: only once the main button is above the viewport.
    // The observer root is stretched far below the screen, so the button counts as
    // "intersecting" while it is on screen or still below it. That also covers
    // jumps (anchor links, restored scroll), where the button never crosses the screen.
    var bar = root.querySelector('[data-pdp2-bar]');
    var cta = root.querySelector('[data-pdp2-cta]');
    if (bar && cta && 'IntersectionObserver' in window) {
      var barIO = new IntersectionObserver(function (entries) {
        var passed = !entries[0].isIntersecting;
        bar.classList.toggle('is-visible', passed);
        if (passed) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      }, { rootMargin: '0px 0px 100000px 0px', threshold: 0 });
      barIO.observe(cta);
    }

    // Gallery: main image slides sideways (swipe, arrows or keyboard) and the
    // thumbnails stay in sync; clicking a thumbnail scrolls the track to that image.
    var gallery = root.querySelector('[data-pdp2-gallery]');
    if (gallery) {
      var track = gallery.querySelector('[data-pdp2-track]');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp2-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp2-thumb]'));
      var current = 0;
      var mark = function (i) {
        current = i;
        slides.forEach(function (slide, k) { slide.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
          t.setAttribute('aria-selected', k === i ? 'true' : 'false');
          if (k === i && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      };
      var goTo = function (i) {
        if (!track || !slides.length) return;
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        mark(i);
      };
      thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { goTo(i); }); });
      var prev = gallery.querySelector('[data-pdp2-prev]');
      var next = gallery.querySelector('[data-pdp2-next]');
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });
      if (track) {
        track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
        });
        var scrollTimer = null;
        track.addEventListener('scroll', function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () {
            var w = track.clientWidth || 1;
            var i = Math.round(track.scrollLeft / w);
            if (i !== current && slides[i]) mark(i);
          }, 80);
        }, { passive: true });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp2-ritual"] && !Shopify.designMode) return;
  try {
    
  // Celular: a seta rola a fileira de vídeos um vídeo por vez e some quando chega ao fim.
  (function () {
    var media = document.querySelector('.pdp2-ritual__media');
    if (!media) return;
    var row = media.querySelector('.pdp2-reels');
    var btn = media.querySelector('[data-p2-reels-next]');
    if (!row || !btn) return;
    var atEnd = function () { return row.scrollLeft + row.clientWidth >= row.scrollWidth - 4; };
    var sync = function () { btn.classList.toggle('is-hidden', atEnd() || row.scrollWidth - row.clientWidth < 8); };
    btn.addEventListener('click', function () {
      var reel = row.querySelector('.pdp2-reel');
      var step = reel ? reel.getBoundingClientRect().width + 12 : row.clientWidth * 0.5;
      row.scrollBy({ left: step, behavior: 'smooth' });
    });
    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp4-formula"] && !Shopify.designMode) return;
  try {
    
  // Celular: os núcleos começam fechados; computador: abertos (o markup já vem aberto).
  (function () {
    var mq = window.matchMedia('(max-width: 899px)');
    var accs = document.querySelectorAll('[data-p4-acc]');
    function sync() { accs.forEach(function (d) { if (mq.matches) { d.open = false; } else { d.open = true; } }); }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stressquiz"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const root = document.querySelector('[data-stress-quiz]');
    if (!root) return;
    const shell = root.querySelector('[data-quiz-shell]');
    const screens = root.querySelectorAll('[data-quiz-screen]');
    const progressFill = root.querySelector('[data-quiz-progress-fill]');
    const progressLabel = root.querySelector('[data-quiz-progress-label]');
    const startBtn = root.querySelector('[data-quiz-start]');
    const optionBtns = root.querySelectorAll('[data-quiz-answer]');
    const skipEmailBtn = root.querySelector('[data-quiz-skip-email]');
    const emailForm = root.querySelector('[data-quiz-email-form]');
    const noteInput = root.querySelector('[data-quiz-note]');
    const restartBtn = root.querySelector('[data-quiz-restart]');
    const ctaBtn = root.querySelector('[data-quiz-result-cta]');

    const state = {
      answers: {}, // q1..q6 → score 0-3
      score: 0,
      tier: null
    };

    const TOTAL_QUESTIONS = 6;

    function show(name) {
      screens.forEach((s) => {
        const isMatch = s.dataset.quizScreen === name;
        s.classList.toggle('is-active', isMatch);
      });
      const isQuestion = /^q\d$/.test(name);
      shell.dataset.showProgress = isQuestion ? 'true' : 'false';
      if (isQuestion) {
        const step = parseInt(name.replace('q', ''), 10);
        const pct = ((step - 1) / TOTAL_QUESTIONS) * 100;
        if (progressFill) progressFill.style.setProperty('--progress', pct + '%');
        if (progressLabel) progressLabel.textContent = step + ' / ' + TOTAL_QUESTIONS;
      }
      // Smooth scroll the section into view (helps mobile after tap)
      requestAnimationFrame(() => {
        if (root.getBoundingClientRect().top < 0) {
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    function recordAnswer(q, score, btn) {
      state.answers[q] = score;
      // Visual confirm
      const siblings = root.querySelectorAll('[data-quiz-answer][data-q="' + q + '"]');
      siblings.forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      // Auto-advance after short pause for visual feedback
      setTimeout(() => {
        const next = q + 1;
        if (next <= TOTAL_QUESTIONS) {
          show('q' + next);
          // Bump progress to next step
          const pct = (q / TOTAL_QUESTIONS) * 100;
          if (progressFill) progressFill.style.setProperty('--progress', pct + '%');
        } else {
          finalizeScore();
          show('email');
        }
      }, 280);
    }

    function finalizeScore() {
      let total = 0;
      for (let i = 1; i <= TOTAL_QUESTIONS; i++) {
        total += state.answers[i] || 0;
      }
      state.score = total;
      // Tier: 0-7 mild, 8-13 moderate, 14+ high (max possible 18)
      if (total <= 7) state.tier = 'mild';
      else if (total <= 13) state.tier = 'moderate';
      else state.tier = 'high';

      // Encode answers into hidden note for Shopify customer record
      if (noteInput) {
        const summary = [
          'Stress quiz score: ' + total + '/18',
          'Tier: ' + state.tier,
          'Q1 overwhelmed=' + (state.answers[1] || 0),
          'Q2 wake tired=' + (state.answers[2] || 0),
          'Q3 shedding=' + (state.answers[3] || 0),
          'Q4 trigger event=' + (state.answers[4] || 0),
          'Q5 evening=' + (state.answers[5] || 0),
          'Q6 duration=' + (state.answers[6] || 0)
        ].join(' | ');
        noteInput.value = summary;
      }
    }

    function paintResult() {
      const titleEl = root.querySelector('[data-quiz-result-title]');
      const bodyEl = root.querySelector('[data-quiz-result-body]');
      const scoreEl = root.querySelector('[data-quiz-result-score]');
      const marker = root.querySelector('[data-quiz-gauge-marker]');
      const recPriceEl = root.querySelector('[data-quiz-rec-price]');
      const recEyebrowEl = root.querySelector('[data-quiz-rec-eyebrow]');

      if (scoreEl) scoreEl.textContent = state.score + ' / 18';

      // Position gauge marker at score%
      const pct = (state.score / 18) * 100;
      if (marker) marker.style.left = pct + '%';

      const copy = {
        mild: {
          title: 'Mild stress signals.',
          body: "Your shedding probably isn't deep stress-driven, but evening calm and consistent nutrition will keep your hair cycle steady. A single bottle is a great starting point.",
          recEyebrow: 'Light support, start with one',
          recPrice: 'Single bottle · $49.99',
          ctaUrl: '/products/ruubyn-hair-gummies?tier=single#purchase-options'
        },
        moderate: {
          title: 'Moderate stress signals.',
          body: 'Your stress and shedding patterns line up, the cortisol-to-shedding cycle is showing in your daily life. A monthly subscription locks in the ritual at the right cadence to start responding.',
          recEyebrow: 'Best fit, monthly ritual',
          recPrice: 'Subscribe monthly · $44.99/mo · saves $5',
          ctaUrl: '/products/ruubyn-hair-gummies?tier=subscribe-monthly#purchase-options'
        },
        high: {
          title: 'High stress-shedding signals.',
          body: "You've likely been carrying this for months. The compounding effect of sustained stress shows up in shedding, sleep, and how your evenings feel. The quarterly subscription is built for exactly this, uninterrupted 90-day protocol, biggest savings, cancel anytime.",
          recEyebrow: 'Top match, committed cycle',
          recPrice: 'Subscribe quarterly · $94.99 · saves 37%',
          ctaUrl: '/products/ruubyn-hair-gummies?tier=subscribe-quarterly#purchase-options'
        }
      };

      const c = copy[state.tier];
      if (titleEl) titleEl.textContent = c.title;
      if (bodyEl) bodyEl.textContent = c.body;
      if (recEyebrowEl) recEyebrowEl.textContent = c.recEyebrow;
      if (recPriceEl) recPriceEl.textContent = c.recPrice;
      if (ctaBtn) ctaBtn.setAttribute('href', c.ctaUrl);
    }

    function restart() {
      state.answers = {};
      state.score = 0;
      state.tier = null;
      root.querySelectorAll('.stress-quiz__option.is-selected').forEach((el) => el.classList.remove('is-selected'));
      show('intro');
    }

    // Events
    if (startBtn) startBtn.addEventListener('click', () => show('q1'));

    optionBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const q = parseInt(btn.dataset.q, 10);
        const score = parseInt(btn.dataset.score, 10);
        recordAnswer(q, score, btn);
      });
    });

    if (skipEmailBtn) {
      skipEmailBtn.addEventListener('click', () => {
        paintResult();
        show('result');
      });
    }

    if (emailForm) {
      emailForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const submitBtn = emailForm.querySelector('[type="submit"]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Saving…';
        }
        // Submit in background — Shopify customer creation
        const formData = new FormData(emailForm);
        fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'text/html' }
        }).catch(() => {/* swallow */}).finally(() => {
          paintResult();
          show('result');
        });
      });
    }

    if (restartBtn) restartBtn.addEventListener('click', restart);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waitlist-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-wq]');
  if (!root) return;

  var QUESTIONS = [
    { q: "How do your days feel lately?",
      opts: ["Light, mostly steady", "Full: busy, but I’m managing", "Heavy, running on fumes", "Please don’t make me answer that"] },
    { q: "And your nights?",
      opts: ["Deep and easy", "Fine, mostly", "Racing mind at lights-out", "What is sleep"] },
    { q: "Be honest, your brush lately:",
      opts: ["Same as always", "A few more strands than usual", "Noticeably more", "I’ve stopped looking"] },
    { q: "Your current hair care routine:",
      opts: ["A full ritual I love", "The basics, most days", "Whatever’s fastest", "Survival mode"] },
    { q: "What would help most right now?",
      opts: ["Stronger-feeling hair", "Fuller-looking hair", "Calmer evenings", "All of it, honestly"] }
  ];

  var SEASONS = {
    light: {
      min: 5, title: "A Light Season",
      body: "Your days sound steady, and steadiness is worth protecting. The habits you build in light seasons are the ones that hold you when the heavier ones come.",
      asks: ["A consistent wind-down hour, kept most nights", "Gentle scalp care: soft brush, low heat", "One simple ritual you never skip"] },
    full: {
      min: 9, title: "A Full Season",
      body: "Busy, but you’re carrying it. Full seasons are where small, repeatable rituals earn their keep, before full quietly tips into heavy.",
      asks: ["A hard stop before midnight, most nights", "Protein and minerals on the plate, daily", "A two-minute nightly anchor, same time, every time"] },
    heavy: {
      min: 13, title: "A Heavy Season",
      body: "There’s a lot on you right now. Heavy seasons ask for less discipline and more care, tiny anchors, kept nightly, instead of grand plans.",
      asks: ["One fixed evening anchor: tiny, non-negotiable", "Lower the heat: on your hair, and on your calendar", "Let the ritual be the easiest thing you do all day"] },
    carrying: {
      min: 17, title: "The Carrying-It-All Season",
      body: "You’re holding more than most people can see. Start smaller than feels productive: one nightly anchor, kept for thirty days, changes more than it should.",
      asks: ["One anchor only, guard it like an appointment", "Ask for one thing off your plate this week", "Softness over strategy, until the season turns"] }
  };

  var screens = {};
  root.querySelectorAll('[data-wq-screen]').forEach(function (el) {
    screens[el.getAttribute('data-wq-screen')] = el;
  });
  var bar = root.querySelector('[data-wq-bar]');
  var state = { i: 0, answers: [] };
  var STORE_KEY = 'ruubyn-wq';

  function show(name) {
    Object.keys(screens).forEach(function (k) {
      screens[k].classList.toggle('is-active', k === name);
    });
    root.scrollIntoView({ block: 'start', behavior: 'auto' });
  }
  function progress(step) { bar.style.width = (step / 7 * 100) + '%'; }

  function seasonFor(score) {
    if (score >= SEASONS.carrying.min) return 'carrying';
    if (score >= SEASONS.heavy.min) return 'heavy';
    if (score >= SEASONS.full.min) return 'full';
    return 'light';
  }

  function renderQuestion() {
    var item = QUESTIONS[state.i];
    root.querySelector('[data-wq-count]').textContent = (state.i + 1) + ' / ' + QUESTIONS.length;
    root.querySelector('[data-wq-qtitle]').textContent = item.q;
    var box = root.querySelector('[data-wq-options]');
    box.innerHTML = '';
    item.opts.forEach(function (label, idx) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wq__opt';
      b.innerHTML = '<span class="wq__opt-key">' + String.fromCharCode(65 + idx) + '</span><span>' + label + '</span>';
      b.addEventListener('click', function () { answer(idx + 1); });
      box.appendChild(b);
    });
    progress(state.i + 1);
    show('question');
  }

  function answer(points) {
    state.answers[state.i] = points;
    if (state.i < QUESTIONS.length - 1) {
      state.i++;
      renderQuestion();
    } else {
      var score = state.answers.reduce(function (a, b) { return a + b; }, 0);
      var key = seasonFor(score);
      try { localStorage.setItem(STORE_KEY, key); } catch (e) {}
      var form = root.querySelector('#wq-founding-form');
      if (form) {
        var tags = form.querySelector('[data-wq-tags]');
        var src = '';
        try {
          var o = JSON.parse(localStorage.getItem('rbn-origin-first') || '{}');
          src = (o.utm_source || '').replace(/[^a-z0-9_-]/gi, '').slice(0, 24);
        } catch (e) {}
        if (tags) tags.value = 'waitlist,quiz,season-' + key + (src ? ',src-' + src : '');
        var ret = form.querySelector('[data-wq-return]');
        if (ret) ret.value = root.getAttribute('data-return-url') + '?joined=1&season=' + key;
      }
      progress(6);
      show('gate');
    }
  }

  function renderResult(key, joined) {
    var s = SEASONS[key] || SEASONS.full;
    root.querySelector('[data-wq-season-title]').textContent = s.title;
    root.querySelector('[data-wq-season-body]').textContent = s.body;
    var ul = root.querySelector('[data-wq-season-asks]');
    ul.innerHTML = '';
    s.asks.forEach(function (a) {
      var li = document.createElement('li');
      li.textContent = a;
      ul.appendChild(li);
    });
    var chip = root.querySelector('[data-wq-joined]');
    if (chip) chip.hidden = !joined;
    progress(7);
    show('result');
  }

  root.querySelector('[data-wq-start]').addEventListener('click', function () {
    state.i = 0; state.answers = [];
    renderQuestion();
  });
  root.querySelector('[data-wq-back]').addEventListener('click', function () {
    if (state.i > 0) { state.i--; renderQuestion(); }
    else { progress(0); show('intro'); }
  });
  root.querySelector('[data-wq-retake]').addEventListener('click', function () {
    try { localStorage.removeItem(STORE_KEY); } catch (e) {}
    if (window.history && history.replaceState) {
      history.replaceState(null, '', root.getAttribute('data-return-url'));
    }
    state.i = 0; state.answers = [];
    progress(0);
    show('intro');
  });

  /* returning from the Shopify form redirect (or a challenge page) */
  var params = new URLSearchParams(window.location.search);
  var joined = params.get('joined') === '1';
  var season = params.get('season');
  if (!season && joined) {
    try { season = localStorage.getItem(STORE_KEY); } catch (e) {}
  }
  if (season && SEASONS[season]) {
    renderResult(season, joined);
  } else {
    progress(0);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
